import React, {Component} from "react";

import * as Variant from "../util/variant";

class Marker extends Component {

    constructor() {
        super();
        this.state = {};
    }

    render() {
        let icon = this.getIcon();
        return <div style={{
            display: "flex", flexDirection: "column", alignItems: "center", position: "absolute",
            transform: "translate(-50%, -100%)"
        }}>
            <img onClick={() => this.props.clicked(this.props.system)} style={{width: 24, height: 24}}
                 src={require("../icons/" + icon + ".png")}/>
        </div>;
    }

    getIcon = () => {
        let s = this.props.system;
        if (!s) {
            return "cctv_grey";
        }
        if (this.props.system.variant != Variant.GAUGE) {
            //camera
            if (this.props.greyed) {
                return "cctv_grey";
            }
            if (s.online == 0) {
                return "cctv_blue";
            }
            return "cctv_green";
        } else {
            //ls
            if (s.online == 0) {
                return "marker_blue";
            }
            if (!s.notFlood()) {
                return "marker_red";
            }
            if (s.notBelow()) {
                return "marker_green";
            } else {
                return "marker_yellow";
            }
        }
    };

}


export default Marker;
